import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared.module';
import { JsonEditorComponent } from './components/json.editor.component';
import { BackupListComponent } from './dialogs/backup-list/backup-list.component';
import { DeleteDialogComponent } from './dialogs/delete-dialog/delete-dialog.component';
import { ImportSheetComponent } from './dialogs/import-sheet/import-sheet.component';
import { ManageBackupsDialogComponent } from './dialogs/manage-backups-dialog/manage-backups-dialog.component';
import { SaveDialogComponent } from './dialogs/save-dialog/save-dialog.component';
import { UploadConfigComponent } from './dialogs/upload-config/upload-config.component';
import { ConfigurationComponent } from './pages/configuration.component';

const routes: Routes = [
  {
    path: '',
    component: ConfigurationComponent,
    data: { animation: 'isLeft' },
  },
];

@NgModule({
  declarations: [
    ConfigurationComponent,
    DeleteDialogComponent,
    SaveDialogComponent,
    JsonEditorComponent,
    ImportSheetComponent,
    BackupListComponent,
    UploadConfigComponent,
    ManageBackupsDialogComponent,
  ],
  imports: [RouterModule.forChild(routes), SharedModule],
  /*exports: [
    ConfigurationComponent,
    DeleteDialogComponent,
    SaveDialogComponent,
    JsonEditorComponent,
    ImportSheetComponent,
    BackupListComponent,
    UploadConfigComponent,
    ManageBackupsDialogComponent,
  ],*/
})
export class LanesConfigModule {}
